import { Group, Input, Tooltip } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  ExtendedUser,
  TodoFile
} from "../../../../../../utils/backend-types";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import type { SiteName } from "../../../../../../utils/enums";
import { splitNameExtension } from "../../../../../../utils/files/splitNameExtension";
import { SYSTEM_USER_NAME } from "../../../../Todos.constants";
import { DocumentNameCell } from "./DocumentNameCell";

declare const SITE_NAME: SiteName;

function getColumns(): Array<MRT_ColumnDef<TodoFile>> {
  return [
    {
      header: "Dateiname",
      accessorKey: "name",
      enableCellHoverReveal: true,
      Cell: ({ row }) => (
        <Group>
          <DocumentNameCell
            documentId={row.original.id}
            documentName={row.original.name}
          />
          {row.original.revoked && (
            <Tooltip label={`Ungültig markiert am ${row.original.revoked}`}>
              <IconAlertTriangle size="1.2rem" />
            </Tooltip>
          )}
        </Group>
      ),
      Edit: ({ row }) => {
        const [fileName, fileExtension] = splitNameExtension(row.original.name);
        return (
          <Input
            defaultValue={fileName}
            onChange={(event) => {
              row._valuesCache.name = `${event.target.value}.${fileExtension}`;
            }}
          />
        );
      },
      size: 500
    },
    {
      header: "Erstellt von",
      accessorKey: "createdBy",
      accessorFn: (row) =>
        row.createdBy ? getUserNameFromValue(row.createdBy) : undefined,
      enableEditing: false,
      size: 90,
      enableCellHoverReveal: true
    },
    {
      header: "Erstellt am",
      accessorKey: "creationDatetime",
      accessorFn: (row) =>
        backendDateOrDateTimeToLuxonDateTime(row.creationDatetime).toJSDate(),
      enableEditing: false,
      sortingFn: "datetime",
      Cell: ({ row }) => row.original.creationDatetime,
      size: 100,
      enableCellHoverReveal: true
    }
  ];
}

function getUserNameFromValue(user: ExtendedUser) {
  let name = "";

  if (user) {
    if (user.name === SYSTEM_USER_NAME) {
      name = SITE_NAME;
    } else {
      name = user.name;
    }
  }

  return name;
}

export { getColumns };
